import { render } from "./WebhookPage.vue?vue&type=template&id=2d9e9acd&ts=true"
import script from "./WebhookPage.vue?vue&type=script&lang=ts"
export * from "./WebhookPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__